import React from 'react';
import BaseComponent from './BaseComponent';
import Button from './Button';

class Title extends BaseComponent {
    createCloseButton() {
        let button = null;

        if (this.props.isClose !== false) {
            button = (
                <Button
                    className="entryLmsClose"
                    onClick={this.props.onClose}
                />
            );
        }

        return button;
    }

    render() {
        return (
            <div className={this.props.className || 'entryLmsTitle'}>
                <div className="entryLmsText">{this.props.children}</div>
                {this.createCloseButton()}
            </div>
        );
    }
}

Title.displayName = 'Title';
Title.propTypes = {};

export default Title;



// WEBPACK FOOTER //
// ./components/CommonSet/Title.js